





































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import { ContractsService } from "@/services/api/contracts.service";
import { ReportsModule } from "@/store/reports.module";
import { ReportAction } from "~/services/report";

@Component
export default class DebtNotificationsView extends Mixins(
  ContractIdValidatorMixin,
) {
  async mounted() {
    await this.validateContractId();
  }
  async created() {
    await this.getDebts();
  }

  sortValue = true;

  get sortValues() {
    return [
      {
        value: true,
        name: this.$t("debtNotifications.filterNew"),
      },
      {
        value: false,
        name: this.$t("debtNotifications.filterOld"),
      },
    ];
  }

  get headers() {
    return [
      {
        text: "",
        value: "contract_add_action_rid",
      },
      {
        text: "",
        value: "debt_notice_number",
      },
      {
        text: "",
        value: "curr_saldo",
      },
      {
        text: "",
        value: "date_formed",
      },
      {
        text: "",
        value: "date_delivery",
      },
      {
        text: "",
        value: "debt_time",
      },
      {
        text: "",
        value: "is_debt_repaid",
      },
      {
        text: "",
        value: "last_pay_date",
      },
      {
        text: "",
        value: "debt_notice_sum",
      },
      {
        text: "",
        value: "last_pay_sum",
      },
    ];
  }

  get saldo() {
    const item = this.items[0];
    if (item) {
      return item.curr_saldo;
    }
    return 0;
  }

  get title() {
    return this.$t("debtNotifications.title");
  }

  public parseDebtRepaid(item: IDebt) {
    // Check only the first in the list
    const first = this.items[0];
    if (first.contract_add_action_rid != item.contract_add_action_rid)
      return false;
    //  and if it has debt, hide it
    if (item.is_debt_repaid) return false;
    return 0;
  }

  items: IDebt[] = [];
  public async getDebts() {
    this.items = await ContractsService.getDebts(this.$route.params.id);
  }

  public async generate(action: ReportAction, id: number) {
    await ReportsModule.generateReport({
      action: action,
      path: "debt-notification.prpt",
      type: "pdf",
      filename: this.title as string,
      query: {
        iContractAddActionsRID: id,
      },
    });
  }
}
